export default {
    custom: {
        search: '查询',
        placeholder: '请输入标签',
        all: '全部',
        noTag: '无标签',
        nickname: '客户昵称/备注：',
        addTime: '添加时间',
        lastConversationTime: '最近消息时间',
        searchPlaceholder: '请输入搜索',
        to: '至',
        startDate: '开始日期',
        endDate: '结束日期',
        client: '客户端：',
        account: '所属账号：',
        query: '查询',
        syncCustomer: '同步客户',
        addTag: '添加标签',
        manualAdd: '手动添加',
        aiAdd: 'AI 打标',
        nickname1: '客户昵称',
        company: '公司名称',
        tag: '标签',
        clickAddTag: '点击打标签',
        wx: '微信',
        gender: '性别',
        remark: '客户备注',
        operation: '操作',
        detail: '详情',
        goChatManage: '前往对话',
        basicInfo: '基本信息',
        tagInfo: '标签信息',
        handTags: '手动添加',
        aiTags: 'AI打标',
        noTag1: '暂无标签',
        manualAdd1: '转人工打标',
        aiTagSetting: 'AI打标签设置',
        aiTagSetting1: '选择标签后，AI将基于与用户的历史对话记录，判断是否满足所选标签的「标签描述」，如满足则进行打标。',
        aiTagSetting2: 'AI打标需要消耗一定时间，完成后可在客户列表中查看打标情况。',
        selectTag: '选择标签：',
        selectCustomer: '请先勾选要添加标签的客户',
        syncCustomerSuccess: '同步客户成功',
        userDetial: {
            nickname: '客户昵称',
            company: '公司名称',
            remark: '客户备注',
            customerType: '客户类型',
            gender: '性别',
            addTime: '添加时间',
            lastConversationTime: '最近对话时间',
        },
        aiTagSuccess: 'AI打标签成功',
        tagSuccess: '打标签成功',
        customerList: '客户列表',
        tagManage: '标签管理',
        searchTag: '输入标签名称搜索',
        createTag: '创建标签',
        tagName: '标签名称',
        tagDescription: '标签描述',
        tagGroup: '标签分组',
        syncThirdPlatform: '同步第三方平台',
        createUsername: '创建人',
        createTime: '创建时间',
        edit: '编辑',
        delete: '删除',
        createGroup: '创建分组',
        groupName: '分组名称',
        editTag: '编辑标签',
        createTag1: '创建标签',
        editTag1: '若修改「标签名称」，则已打标客户的对应标签也将更名；若设置了标签同步到第三方平台，第三方平台标签也不会同步更名。',
        editTag2: '若修改「标签描述」，则使用 AI 打标签时，将会根据最新的标签描述进行打标，已打标客户不变。',
        editTag3: '若修改同步设置，新打标客户将会按照最新规则触发标签同步（或停止同步），历史已打标客户不会同步。',
        editTag4: '标签描述非常重要。使用AI打标签功能时，将根据标签描述以及客户与AI的<br />历史对话进行匹配打标，请用具体、清晰的语言填写标签的描述。',
        tagName1: '标签名称：',
        tagDescription1: '标签描述：',
        placeholderTagName: '请输入标签名称',
        placeholderTagDescription: '请输入标签描述',
        tagGroup2: '标签分组：',
        tagSync: '标签同步：',
        tagSync1: '同步至企业微信',
        tagSync2: '勾选后，如托管企微账号的客户添加了该标签',
        tagSync3: '则标签会同步显示在企业微信官方客户个人标签中',
        tagSync4: '同步至微信',
        tagSync5: '勾选后，如托管微信账号的好友添加了该标签',
        tagSync6: '则标签会同步显示在微信官方好友标签中',
        editGroup: '编辑分组',
        createGroup1: '创建分组',
        groupName1: '分组名称：',
        placeholderGroupName: '请输入分组名称',
        createGroupSuccess: '创建分组成功',
        editGroupSuccess: '修改分组成功',
        deleteGroup: '是否确认删除此分组?',
        deleteGroupSuccess: '删除分组成功',
        deleteSuccess: '删除成功',
        deleteTag: '是否确认删除此标签?',
        deleteTagSuccess: '删除标签成功',
        pleaseEnterTagName: '请填写标签名称',
        pleaseEnterTagDescription: '请填写标签描述',
        editTagSuccess: '修改标签成功',
        createSuccess: '创建成功',
    }
}